// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"57cd1f6f","831":"97933fb1"}[chunkId] + ".chunk.js";
};